import React, { Fragment } from "react";

import Blocks from "../IME/Blocks";

const MentorBiography = ({
  setmentorbio,
  profile: { avatar, firstname, lastname, jobtitle, location, bioblocks },
}) => {
  return (
    <Fragment>
      <div className="modal-overlay">
        <div className="bio-box">
          <i
            className="fas fa-times fa-2x message-x"
            onClick={() => setmentorbio(false)}
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font bold">
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="user-online-item">{jobtitle}</li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          {bioblocks.length > 0 ? (
            <div>
              <div className="post-type red bold px-10">Biography</div>
              <div className="scroll-container">
                <div className="user-request-text-alt">
                  <p className="white">
                    <Blocks bioblocks={bioblocks} />
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="no-user-content">
              <p className="no-content-message red bold">
                No Biography Available
              </p>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default MentorBiography;
